import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ADPResourceService, CustomFormControl, Resource } from 'digital-core';
import { AccountService } from 'src/app/core/services/account.service';
import { OtpChannel, SendOTPRequest } from 'src/app/model/account/user-otp-request';

@Component({
  selector: 'pgh-extra-information',
  templateUrl: './extra-information.component.html',
  styleUrls: ['./extra-information.component.scss'],
})
export class ExtraInformationComponent implements OnInit {
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  @Input() phoneNumber: string = '';
  @Input() showOtpScreen = false;
  @Output() sendOtpComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() extraInformationComplete: EventEmitter<{ firstName: string, lastName: string, phoneNumber: string }> = new EventEmitter();

  otpRequest: SendOTPRequest;
  inputError = { firstName: '', lastName: '', phoneNumber: '' };
  firstNameResourceData: Resource;
  lastNameResourceData: Resource;
  phoneNumberResourceData: Resource;

  extraInformationForm = new UntypedFormGroup({
    firstName: new CustomFormControl('', []),
    lastName: new CustomFormControl('', []),
    phoneNumber: new CustomFormControl('', [])
  });

  firstNameControl: UntypedFormControl = this.extraInformationForm.get('firstName') as UntypedFormControl;
  lastNameControl: UntypedFormControl = this.extraInformationForm.get('lastName') as UntypedFormControl;
  phoneNumberControl: UntypedFormControl = this.extraInformationForm.get('phoneNumber') as UntypedFormControl;

  public constructor(
    private router: Router,
    public resourceService: ADPResourceService,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {
    if (this.firstName?.length > 0) {
      this.firstNameControl.setValue(this.firstName);
    }
    if (this.lastName?.length > 0) {
      this.lastNameControl.setValue(this.lastName);
    }
    if (this.phoneNumber?.length > 0) {
      this.phoneNumberControl.setValue(this.phoneNumber);
    }
    this.firstNameControl.updateValueAndValidity();
    this.lastNameControl.updateValueAndValidity();
    this.phoneNumberControl.updateValueAndValidity();
    this.firstNameResourceData = this.resourceService.getResourceObject('Signup_InvitedUser_ExtraInfo_FirstName_Field');
    this.lastNameResourceData = this.resourceService.getResourceObject('Signup_InvitedUser_ExtraInfo_LastName_Field');
    this.phoneNumberResourceData = this.resourceService.getResourceObject('Signup_InvitedUser_ExtraInfo_PhoneNumber_Field');
  }

  isLetters(event): boolean {
    const iKeycode = event.keyCode;
    return (iKeycode >= 65 && iKeycode <= 90) || (iKeycode >= 97 && iKeycode <= 122) || iKeycode === 39;
  }

  createOtp() {
    if (!this.extraInformationForm.valid) {
      return;
    }
    this.inputError = undefined;
    this.otpRequest = {
      channel: OtpChannel[OtpChannel.sms],
      userContact: this.phoneNumberControl.value,
      maskedUserContact: undefined,
    };

    this.accountService.sendOTPCode(this.otpRequest).subscribe({
      next: (resp) => {
        this.showOtpScreen = true;
        this.sendOtpComplete.emit(this.showOtpScreen);
      },
      error: (err) => {
        if (err.error && err.error.ErrorCode == 'CreateOTP') {
          this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_CreateOTP' }});
        } else if (err.error && err.error.ErrorCode == 'SMSNotSupportedOnLandline') {
          this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_SMSNotSupportedOnLandline' }});
        } else if (err.error && err.error.ErrorCode == 'InvalidPhoneNumber') {
          this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'Global_Error_Code_InvalidPhoneNumber' }});
        } else if (err.error && err.error.ErrorCode == 'OTPSendAttemptReached') {
          this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_OTPSendAttemptReached' }});
        } else {
          this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_HavingTrouble' }});
        }
      }
    });
  }

  verifyOtp(event) {
    if (event.userContact) {
      this.extraInformationComplete.emit({
        firstName: this.firstNameControl.value,
        lastName: this.lastNameControl.value,
        phoneNumber: this.phoneNumberControl.value,
      });
    }
  }
}
